// @ts-strict-ignore
import React, { useContext } from 'react';
import {
  Button,
  ButtonSize,
  ButtonVariant,
  Separator,
} from '@usealloy/component-library';
import { IsolatedEditorContainer } from 'flow/editor/styles';
import {
  StyledTipCallout,
  StyledAggregationCriteriaContainer,
  StyledAggregationSubEditorLayout,
  StyledAggregationSubEditorRow,
  StyledAggregationSubEditorActions,
} from './styles';
import BaseAggregationsSection from './BaseAggregationsSection';
import AggregationFiltersSection from './AggregationFiltersSection';
import AggregationNameAndDescription from './AggregationNameAndDescription';
import { AggregationEditorContext } from './context';

const AggregationsSubEditorContainer = () => {
  const {
    handleSave, handleCancel, aggregationEditorContainerRef, isSaveDisabled,
  } = useContext(AggregationEditorContext);

  return (
    <IsolatedEditorContainer ref={aggregationEditorContainerRef}>
      <StyledAggregationSubEditorLayout>
        <StyledAggregationSubEditorRow>
          <StyledAggregationCriteriaContainer>
            <StyledTipCallout text="Build your custom aggregation by selecting the options below." />
            <BaseAggregationsSection />
            <AggregationFiltersSection />
          </StyledAggregationCriteriaContainer>
          <AggregationNameAndDescription />
        </StyledAggregationSubEditorRow>
        <Separator />
        <StyledAggregationSubEditorActions>
          <Button
            size={ButtonSize.small}
            variant={ButtonVariant.secondary}
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            size={ButtonSize.small}
            variant={ButtonVariant.primary}
            onClick={handleSave}
            disabled={isSaveDisabled}
          >
            Done
          </Button>
        </StyledAggregationSubEditorActions>
      </StyledAggregationSubEditorLayout>
    </IsolatedEditorContainer>
  );
};

export default AggregationsSubEditorContainer;
